<script setup lang="ts">
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { computed, reactive, ref, toRefs } from "vue";
import {
  FormInput,
  FormLabel,
  FormCheck,
  FormSelect
} from "../../../base-components/Form";
import Preview from "../../../base-components/Preview";
import { IGetnetPOSConfig } from "@fixeduy/restaurantestypes";

interface Props {
  indice: number;
  pos: IGetnetPOSConfig | null;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  (e: "actualizar", data: { indice: number; pos: IGetnetPOSConfig }): void;
}>();

// const localesStore = useLocalesStore();

const formData = reactive({
  nombre: props.pos?.nombre ?? "",
  local: props.pos?.local ?? "",
  TermCod: props.pos?.TermCod ?? "",
  imprime: props.pos?.imprime ?? true
});

const rules = {
  nombre: {
    required: helpers.withMessage(
      "El campo nombre no puede estar vacío",
      required
    )
  },
  local: {
    required: helpers.withMessage(
      "El campo local no puede estar vacío",
      required
    )
  },
  TermCod: {
    required: helpers.withMessage(
      "El campo TermCod no puede estar vacío",
      required
    )
  }
};

const actualizar = () => {
  const datos: IGetnetPOSConfig = {
    nombre: formData.nombre,
    local: formData.local,
    TermCod: formData.TermCod,
    imprime: formData.imprime
  };
  emit("actualizar", { indice: props.indice, pos: datos });
};

const cuartaColumna = computed(() => {
  // return localesStore.localesActivos.length > 1;
});
</script>

<template>
  <Preview class="box mt-2">
    <div class="border">
      <div class="flex flex-row rounded-md w-full space-x-3">
        <div class="flex-1 p-3">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel> Nombre (interno Atiendo) </FormLabel>
            </div>
            <div class="flex-1">
              <FormInput
                type="text"
                v-model.trim="formData.nombre"
                placeholder="Nombre"
                @change="actualizar"
              />
            </div>
          </div>
        </div>
        <div class="flex-1 p-3">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel> Código de terminal (brindado por Getnet) </FormLabel>
            </div>
            <div class="flex-1">
              <FormInput
                type="text"
                v-model.trim="formData.TermCod"
                placeholder="TermCod"
                @change="actualizar"
              />
            </div>
          </div>
        </div>
        <div class="flex-1 p-3">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel> Local </FormLabel>
            </div>
            <div class="flex-1">
              <FormSelect
                v-model="formData.local"
                id="local"
                @change="actualizar"
              >
                <option value="" disabled>Local</option>

                <!-- <option v-for="local in localesStore.localesActivos" :key="local.id" :value="local.id">
                  {{ local.nombre }}
                </option> -->
              </FormSelect>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-1 p-3">
        <div class="flex">
          <div class="flex-none w-50 text-right pr-5 mt-2">
            <FormLabel> Pos imprime voucher</FormLabel>
          </div>
          <div class="flex-1">
            <FormCheck.Input
              id="checkbox-switch-1"
              type="checkbox"
              v-model="formData.imprime"
              @change="actualizar"
            />
          </div>
        </div>
      </div>
    </div>
  </Preview>
</template>
